/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
  GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams,
  GetApiV1CourseregistrationEnrollmentGridChildren401,
  GetApiV1CourseregistrationEnrollmentGridChildren500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentGridChildren.ts";

function getGetApiV1CourseregistrationEnrollmentGridChildrenUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/grid/children` as const,
  };
  return res;
}

/**
 * @description Carrega sob demanda os alunos de um grupo específico (turma + polo) do grid de matrículas, com suporte a paginação. Deve ser chamado ao expandir uma linha do grid passando o filtro (childrenFilter) do elemento pai. Use poloId = 0 ou omita para grupos sem polo (MBX Online). **(Requer Authorization para autenticação)**
 * @summary Retorna os alunos (children) paginados de um grupo do grid de matrículas (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/grid/children}
 */
export async function getApiV1CourseregistrationEnrollmentGridChildren(
  params?: GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentGridChildren401
      | GetApiV1CourseregistrationEnrollmentGridChildren500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentGridChildrenUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
